import { Box } from '@mui/material';
import { Breadcrumbs } from 'components/Breadcrumbs';

import { useBreadcrumbs } from 'contexts/BreadcrumbsContext';

const BreadcrumbsWrapper = () => {
  const { items } = useBreadcrumbs();
  return (
    <Box flexGrow={1}>
      <Breadcrumbs items={items} source="items" />
    </Box>
  );
};

export default BreadcrumbsWrapper;
